<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5RLvoL/images/Cover.jpg?1735274501433" alt="This image is the cover for the book Haunted Fredericksburg, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Fredericksburg, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>Discover the spirits that still walk the banks of the Rappahannock River. <br/> Though the streets of Fredericksburg are peaceful today, the ghosts of the past still lurk in the shadows. From the colonial era to the Civil War, the region witnessed some of the most dramatic and bloody events in American history. A woman in white is seen walking the grounds of Chatham Manor every seven years. At the Rising Sun Tavern, a rowdy tavern keeper continues to make his presence known two hundred years after his death. The spirit of Mary Washington, the mother of the first president, has been seen tending her beloved garden. <br/> Join historian Michelle L. Hamilton on a spirited tour of haunted Fredericksburg.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle L. Hamilton
      </h2>
      
      <p class="authorDescription body article">Michelle L. Hamilton earned her MA in history from San Diego State University. Hamilton is the author or editor of several books, including "I Would Still Be Drowned in Tears": Spiritualism in Abraham Lincoln's White House , Mary Ball Washington: The Mother of George Washington and Virginia's Ghosts and Legends (vol. 1). She has published articles in the Morbid Curious and the Feminine Macabre . Her latest books-- Civil War Ghosts , Haunted Land and Virginia's Haunted History --were published by Haunted Road Media. A lifelong student of history, Hamilton has worked as a docent at several museums across the county. She is currently the manager of the Mary Washington House in Fredericksburg, Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c37f229